import React from 'react';
import './SkeletonLoader.css';

const SkeletonLoader = ({ 
  type = 'card', 
  count = 1, 
  width = '100%', 
  height = '200px',
  className = '' 
}) => {
  const renderSkeleton = () => {
    switch (type) {
      case 'card':
        return (
          <div className={`skeleton-card ${className}`} style={{ width, height }}>
            <div className="skeleton-image"></div>
            <div className="skeleton-content">
              <div className="skeleton-line skeleton-line-small"></div>
              <div className="skeleton-line skeleton-line-medium"></div>
            </div>
          </div>
        );
      case 'project':
        return (
          <div className={`skeleton-project ${className}`} style={{ width, height }}>
            <div className="skeleton-image"></div>
            <div className="skeleton-rectangle">
              <div className="skeleton-line skeleton-line-small"></div>
              <div className="skeleton-line skeleton-line-medium"></div>
            </div>
          </div>
        );
      case 'line':
        return (
          <div className={`skeleton-line ${className}`} style={{ width, height }}></div>
        );
      default:
        return (
          <div className={`skeleton-default ${className}`} style={{ width, height }}></div>
        );
    }
  };

  if (count > 1) {
    return (
      <>
        {Array.from({ length: count }, (_, index) => (
          <div key={index}>
            {renderSkeleton()}
          </div>
        ))}
      </>
    );
  }

  return renderSkeleton();
};

export default SkeletonLoader;
